import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class BibagueTraitement {

  constructor(private http: HttpClient,) { }


    addNewTreatments(typeCorrespondant) {
        return this.http.post(Context.apiUrl + 'treatmentBibague/', typeCorrespondant);
    }

    updateTreatments(typeCorrespondant,id) {
        return this.http.put(Context.apiUrl + 'treatmentBibague/'+id , typeCorrespondant);
    }


    getAllTreatments(id) {
        return this.http.get(Context.apiUrl + 'treatmentBibague/'+ id);
    }

    getOneBibagueById(id) {
        return this.http.get(Context.apiUrl + 'treatmentBibague/get/'+ id);
    }
 



}
